import {
  AutoComplete,
  Button,
  Cascader,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Tabs,
  DatePicker,
  Card,
  Upload,
  message,
} from "antd";
import React, { useState } from "react";
import LotteryList from "./component/LotteryList";
import DatePickerComponent from "./component/DatePickerComponent";
import HistoryWeekModal from "./component/HistoryWeekModal";
import Operate from "../../../components/operate";
import { DatePickerWeekComponent } from "./component/DatePickerComponent";
import * as service from "./service";
import { PlusOutlined } from "@ant-design/icons";
// import { loyyeryData } from "./mock";
import styles from "./index.module.less";
import FormItem from "antd/es/form/FormItem";
const { Option } = Select;
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};
const FormWrap = React.forwardRef(({ weekDayNo, cloneData, formRef }) => {
  const [form] = Form.useForm();
  const lotteryListRef = React.useRef();
  React.useEffect(() => {}, []);
  // 暴露组件的方法
  React.useImperativeHandle(formRef, () => ({
    getFormData,
  }));
  React.useEffect(() => {
    createCloneData(cloneData);
  }, [cloneData]);
  const createCloneData = (newCloneData) => {
    console.log("newCloneData", newCloneData);
    form.setFieldsValue({
      ...newCloneData,
    });
  };
  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };
  const getFormData = () => {
    return new Promise((resolve, reject) => {
      form
        .validateFields()
        .then(async (values) => {
          const lotteryList = await lotteryListRef.current.getFormData();
          resolve({
            ...values,
            lotteryList,
          });
        })
        .catch(async (error) => {
          lotteryListRef.current.getFormData();
          message.error(`周${weekDayNo}, 表单校验未通过`);
          reject();
        });
    });
  };
  return (
    <Form
      className={styles.formWrap}
      {...formItemLayout}
      form={form}
      name="register"
      onFinish={onFinish}
      initialValues={
        {
          // lotteryPreJoinNumber: 50
          // lotteryTitle: loyyeryData.lotteryTitle,
          // lotteryType: loyyeryData.lotteryType,
          // lotteryStartTime: loyyeryData.lotteryStartTime,
          // lotteryTime: loyyeryData.lotteryTime,
          // probability: loyyeryData.probability,
          // lotteryList: loyyeryData.lotteryList,
        }
      }
      scrollToFirstError
    >
      <Card title="奖品信息">
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item
              name="lotteryTitle"
              label="活动名称"
              rules={[
                {
                  required: true,
                  message: "请输入",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="lotteryType"
              label="抽奖规则"
              rules={[
                {
                  required: true,
                  message: "请选择",
                },
              ]}
            >
              <Select>
                <Option value={1}>按时间自动开奖</Option>
                {/* <Option value={2}>按人数自动分开奖</Option>
                <Option value={3}>即开即中</Option> */}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="lotteryStartTime"
              label="活动开始时间"
              rules={[
                {
                  required: true,
                  message: "请选择",
                },
              ]}
            >
              <DatePickerComponent />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="lotteryTime"
              label="抽奖时间"
              rules={[
                {
                  required: true,
                  message: "请选择",
                },
              ]}
            >
              <DatePickerComponent />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="lotteryPreJoinNumber"
              label="预定参与人数"
              rules={[
                {
                  required: false,
                  message: "请输入",
                },
              ]}
            >
              <InputNumber
                placeholder="请输入预定参与人数"
                className={styles.lotteryItemInput}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="probability"
              label="备注"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 20 }}
              rules={[
                {
                  required: false,
                  message: "请输入",
                },
              ]}
            >
              <Input.TextArea autoSize={true} />
            </Form.Item>
          </Col>
        </Row>
      </Card>
      <Card title="奖品列表">
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              name="lotteryList"
              labelCol={{ span: 0 }}
              wrapperCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
              hasFeedback
            >
              <LotteryList lotteryListRef={lotteryListRef} />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Form>
  );
});
const App = () => {
  const [form] = Form.useForm();
  const weekOneForm = React.useRef();
  const weekTwoForm = React.useRef();
  const weekThreeForm = React.useRef();
  const weekFourForm = React.useRef();
  const weekFiveForm = React.useRef();
  const weekSixForm = React.useRef();
  const weekSevenForm = React.useRef();
  const historyWeekModalNode = React.useRef();
  const [cloneData, changeCloneData] = React.useState(null);
  const [confirmLoading, changeConfirmLoading] = React.useState(false);
  React.useEffect(() => {
    createCloneData(cloneData);
  }, [cloneData]);
  const createCloneData = (newCloneData) => {
    console.log("newCloneData", newCloneData);
    form.setFieldsValue({
      weekNo: cloneData && cloneData.weekDate,
      remark: cloneData && cloneData.remark,
    });
  };
  const onShowHistoryWeek = () => {
    historyWeekModalNode.current.onOpen();
  };
  const setCloneData = (weekData) => {
    changeCloneData(weekData);
  };
  const onSave = async () => {
    // 先校验周数据
    const resWeekForm = await form.validateFields();
    const weekOneFormData = await weekOneForm.current.getFormData();
    const weekTwoFormData = await weekTwoForm.current.getFormData();
    const weekThreeFormData = await weekThreeForm.current.getFormData();
    const weekFourFormData = await weekFourForm.current.getFormData();
    const weekFiveFormData = await weekFiveForm.current.getFormData();
    const weekSixFormData = await weekSixForm.current.getFormData();
    const weekSevenFormData = await weekSevenForm.current.getFormData();
    const weekData = [
      weekOneFormData,
      weekTwoFormData,
      weekThreeFormData,
      weekFourFormData,
      weekFiveFormData,
      weekSixFormData,
      weekSevenFormData,
    ];
    console.log("resWeekForm", resWeekForm);
    console.log("weekData", weekData);
    const queryData = {
      weekNo: resWeekForm.weekNo.weekNo,
      weekDays: resWeekForm.weekNo.weekDays.join(","),
      weekTimeBetween: `${resWeekForm.weekNo.weekDays[0]} 至 ${resWeekForm.weekNo.weekDays[6]}`,
      remark: resWeekForm.remark,
      lotteryList: weekData,
    };
    console.log("queryData", queryData);
    changeConfirmLoading(true);
    const res = await service.createWeekActive(queryData);
    changeConfirmLoading(false);
    if (res.code === 0) {
      message.success("创建成功");
    }
  };
  console.log("cloneData", cloneData);
  return (
    <div className={styles.pageWrap}>
      <Card title="周基础信息">
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          form={form}
          initialValues={{
            weekNo: cloneData && cloneData.weekNo,
            remark: cloneData && cloneData.remark,
          }}
        >
          <Row>
            <Col span={6}>
              <FormItem
                label="周"
                name="weekNo"
                rules={[
                  {
                    required: true,
                    message: "请选择",
                  },
                ]}
              >
                <DatePickerWeekComponent />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem label="备注" name="remark">
                <Input.TextArea />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Card>
      <Tabs
        defaultActiveKey="1"
        items={[
          {
            label: `周一`,
            key: "1",
            forceRender: true,
            children: (
              <FormWrap
                weekDayNo={1}
                cloneData={cloneData && cloneData.children[0]}
                formRef={weekOneForm}
              />
            ),
          },
          {
            label: `周二`,
            key: "2",
            forceRender: true,
            children: (
              <FormWrap
                weekDayNo={2}
                cloneData={cloneData && cloneData.children[1]}
                formRef={weekTwoForm}
              />
            ),
          },
          {
            label: `周三`,
            key: "3",
            forceRender: true,
            children: (
              <FormWrap
                weekDayNo={3}
                cloneData={cloneData && cloneData.children[2]}
                formRef={weekThreeForm}
              />
            ),
          },
          {
            label: `周四`,
            key: "4",
            forceRender: true,
            children: (
              <FormWrap
                weekDayNo={4}
                cloneData={cloneData && cloneData.children[3]}
                formRef={weekFourForm}
              />
            ),
          },
          {
            label: `周五`,
            key: "5",
            forceRender: true,
            children: (
              <FormWrap
                weekDayNo={5}
                cloneData={cloneData && cloneData.children[4]}
                formRef={weekFiveForm}
              />
            ),
          },
          {
            label: `周六`,
            key: "6",
            forceRender: true,
            children: (
              <FormWrap
                weekDayNo={6}
                cloneData={cloneData && cloneData.children[5]}
                formRef={weekSixForm}
              />
            ),
          },
          {
            label: `周日`,
            key: "7",
            forceRender: true,
            children: (
              <FormWrap
                weekDayNo={7}
                cloneData={cloneData && cloneData.children[6]}
                formRef={weekSevenForm}
              />
            ),
          },
        ]}
      ></Tabs>
      <Operate>
        <Button type="primary" onClick={onSave} loading={confirmLoading}>
          保存
        </Button>
      </Operate>
      <div className={styles.cloneWeekCreate}>
        <Button type="primary" onClick={onShowHistoryWeek}>
          复制往期
        </Button>
      </div>

      <HistoryWeekModal
        historyWeekModalRef={historyWeekModalNode}
        onSubmit={setCloneData}
      ></HistoryWeekModal>
    </div>
  );
};
export default App;
